module.exports = {"220602001":"新建街道","220602002":"通沟街道","220602003":"东兴街道","220602004":"红旗街道","220602005":"城南街道","220602006":"江北街道","220602007":"河口街道","220602008":"板石街道","220602100":"七道江镇","220602101":"六道江镇","220602102":"红土崖镇","220602103":"三道沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220602.json
// module id = 591
// module chunks = 0